<div
  *transloco="let t; prefix: 'shared.bom.additionalInformation.costElements'"
>
  @if (currentSplitType) {
    <button
      mat-button
      class="!mr-4"
      queryParamsHandling="merge"
      (click)="toggleSplitType.emit()"
    >
      {{ t(buttonKey) }}
    </button>
  }
</div>
